<style lang="less" rel="stylesheet/less">
    .slider{
        background:#ccc;
        overflow:hidden;
        position:relative;
        .title{
            position:absolute;
            bottom:0;
            left:0;
            right:0;
            z-index:10;
            color:#fff;
            background:linear-gradient(rgba(0,0,0,0),rgba(0,0,0,0.5));
            padding:0 10px;
            line-height:30px;
            font-size:14px;
            pointer-events: none;
        }
    }
</style>
<template>
    <div class="slider" v-if="list.length">
        <sss class="inner" @slide="onSlide" ref="slider" :pages="pages" @click="sliderClick" :sliderinit="sliderConfig" style="height:100px;"></sss>
        <div class="title">{{currentTitle}}</div>
    </div>
</template>
<script type="text/ecmascript-6">

    export default {
        props:['list'],
        data() {
            return {
                currentTitle:'',
                sliderConfig:{
                    direction:'horizontal',
                    currentPage: 0,//当前页码
                    thresholdDistance: 100,//滑动判定距离
                    thresholdTime: 2000,//滑动判定时间
                    autoplay:3000,//自动滚动[ms]
                    loop:true,//循环滚动
                    infinite:1,//无限滚动前后遍历数
                    slidesToScroll:1,//每次滑动项数
                }
            }
        },
        computed: {
            pages(){
                return this.list.map(a=>{
                    return {
                        title:'',
                        id:a.id,
                        style:{
                            background:`url(${ a.cover_images[0]})  no-repeat center center`,
                            backgroundSize:'contain'
                        }
                    }
                })
            }
        },
        methods: {
            sliderClick(item){
                $router.go({name:'news-detail',query:{id:item.id}})
            },
            onSlide(idx){
                this.currentTitle = this.list[idx].title;
            },
        },
        components: {
            sss:require('./the-slider')
        },
        mounted() {

        }
    }
</script>


// WEBPACK FOOTER //
// Slider.vue?0888122b